exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btnList-phone_btnBox_2sY5U{\r\n    position: absolute;\r\n    height:36px;\r\n    display:-webkit-box;\r\n    display:-webkit-flex;\r\n    display:-ms-flexbox;\r\n    display:flex;\r\n    -webkit-box-pack: center;\r\n    -webkit-justify-content: center;\r\n        -ms-flex-pack: center;\r\n            justify-content: center;\r\n    -webkit-box-align:center;\r\n    -webkit-align-items:center;\r\n        -ms-flex-align:center;\r\n            align-items:center;\r\n    right:1rem;\r\n    top:0.5rem;\r\n}", ""]);

// exports
exports.locals = {
	"btnBox": "btnList-phone_btnBox_2sY5U"
};